import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { RetroList } from "../components/RetroList";
import { useTranslation } from "../i18n";

export function HomePage() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!auth.loading && !auth.staff) {
      navigate("/login");
    }
  }, [auth, navigate]);

  if (auth.loading) {
    return (
      <div className="page-container flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <div className="mb-4 inline-block h-10 w-10 animate-spin rounded-full border-2 border-nm-primary border-t-transparent" />
          <p className="font-medium text-ink-muted">{t("common.loading")}</p>
        </div>
      </div>
    );
  }

  if (!auth.staff) {
    return null;
  }

  return (
    <div className="page-container">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4 animate-fadeIn">
        <div>
          <h1 className="mb-1 text-3xl font-bold tracking-tight text-ink md:text-4xl">
            {t("home.title")}
          </h1>
          <p className="text-ink-muted">{t("home.subtitle")}</p>
        </div>

        {/* Creating a retro is a screen of its own now: choosing a format is a
            real decision, and it needs room to show what each board looks like. */}
        <Link to="/new" data-testid="new-retro" className="btn-accent whitespace-nowrap">
          + {t("home.newRetro")}
        </Link>
      </div>

      <RetroList />
    </div>
  );
}
